import {faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import {GetInfo, UpdateServicesAction} from "../../redux/actions/auth";
import useQuery from "../../useQuery";

const days = [
    {
        label: "Mon",
        value: "Monday",
        id: "monday",
    },
    {
        label: "Tue",
        value: "Tuesday",
        id: "tuesday",
    },
    {
        label: "Wed",
        value: "Wednesday",
        id: "wednesday",
    },
    {
        label: "Thurs",
        value: "Thursday",
        id: "thursday",
    },
    {
        label: "Fri",
        value: "Friday",
        id: "friday",
    },
    {
        label: "Sat",
        value: "Saturday",
        id: "saturday",
    },
    {
        label: "Sun",
        value: "Sunday",
        id: "sunday",
    },
];

const CareRegistration2 = ({auth, updateServices, getInfo}) => {
    const emptyService = {
        service_types: [],
        available_days: [
            {label: "Monday", value: false},
            {label: "Tuesday", value: false},
            {label: "Wednesday", value: false},
            {label: "Thursday", value: false},
            {label: "Friday", value: false},
            {label: "Saturday", value: false},
            {label: "Sunday", value: false},
        ],
        unit: "hour",
        per_hour: "",
        hour_availability_id: "",
        service_for_age_id: "",
        cancellation_policy_id: "",
    };

    const navigate = useNavigate();

    const [payload, setPayload] = useState({});
    const [otherService, setOtherService] = useState({});
    const [hour_availability, setHourAvailability] = useState([]);
    const [service_for_age, setServiceForAge] = useState([]);
    const [cancellation_policy, setCancellationPolicy] = useState([]);
    console.log("cancellation_policy",cancellation_policy);

    const query = useQuery();

    const [loading, setLoading] = useState(true);

    const onCheckServiceType = (slug, service_type_title) => {
        let newPayload = {...payload};
        console.log(newPayload[slug]);
        if (
            newPayload[slug] &&
            newPayload[slug].service_types?.includes(service_type_title)
        ) {
            newPayload[slug].service_types = newPayload[
                slug
                ].service_types.filter(
                (singleServiceType) => singleServiceType != service_type_title
            );
        } else if (newPayload[slug] && newPayload[slug].service_types) {
            newPayload[slug].service_types.push(service_type_title);
        } else if (!newPayload[slug]) {
            let newService = {...emptyService};
            newService.service_types = [service_type_title];
            newPayload[slug] = newService;
        }
        // console.log(newPayload);
        setPayload(newPayload);
    };

    const onOtherServiceType = (slug, service_type_title) => {
        let otherServicee = {...otherService};
        otherServicee[slug] = service_type_title;
        setOtherService(otherServicee);
    };

    const onPerHourChange = (slug, per_hour) => {
        let newPayload = {...payload};
        newPayload[slug].per_hour = per_hour;
        setPayload(newPayload);
    };

    const onDaysChange = (slug, days) => {
        let newPayload = {...payload};
        if (newPayload[slug]) {
            newPayload[slug].available_days = newPayload[
                slug
                ].available_days.map((day) => {
                if (day.label == days) {
                    return {
                        ...day,
                        value: !day.value,
                    };
                } else {
                    return {...day};
                }
            });
        } else if (!newPayload[slug]) {
            let newService = emptyService;
            newService.available_days = newService.available_days.map((day) => {
                if (day.label == days) {
                    return {
                        ...day,
                        value: !day.value,
                    };
                } else {
                    return {...day};
                }
            });
            newPayload[slug] = newService;
        }
        setPayload(newPayload);
    };

    const onHourAvailabilityChange = (slug, hour_availability_id) => {
        let newPayload = {...payload};
        newPayload[slug].hour_availability_id = hour_availability_id;
        setPayload(newPayload);
    };

    const onServiceAgeChange = (slug, service_age_id) => {
        let newPayload = {...payload};
        newPayload[slug].service_for_age_id = service_age_id;
        console.log(newPayload);
        setPayload(newPayload);
    };

    const onCancellationPolicyChange = (slug,cancellation_policy_id) => {
        console.log("changing");
        let newPayload = {...payload};
        newPayload[slug].cancellation_policy_id = cancellation_policy_id;
        console.log(newPayload);
        setPayload(newPayload);
    };

    const getServicesMeta = async () => {
        try {
            const res = await config.getApi(
                config.services.allServicesMeta(),
                config.bearerHeaders(auth.token)
            );
            if (res) {
                setHourAvailability(res.response.data.hours_per_day);
                setServiceForAge(res.response.data.service_for_ages);
                setCancellationPolicy(res.response.data.cancellation_policy);
                // console.log(res.response.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getInfo();
        getServicesMeta();
        let newOtherService = {...otherService};
        let newPayload = {...payload};
        console.log("auth.user.services",auth.user.services);
        auth.user.services.map((service, serviceIndex) => {
            newOtherService[service.service.slug] = "";
            if (
                auth.user.services[serviceIndex].per_hour != "" ||
                auth.user.services[serviceIndex] != "0"
            ) {
                newPayload[service.service.slug] = {...emptyService};
                newPayload[service.service.slug].per_hour =
                    auth.user.services[serviceIndex].per_hour;
                newPayload[service.service.slug].unit =
                    auth.user.services[serviceIndex].unit;

                let schedulee = auth.user.schedule.filter(
                    (singleSchedule) =>
                        singleSchedule.service_id == service.service.id
                );
                let newScheduleForPayload = [];
                schedulee.map((singleSchedule) => {
                    newScheduleForPayload.push({
                        label: config.caiptalize(singleSchedule.availability),
                        value:
                            singleSchedule.availability_status === 1
                                ? true
                                : false,
                    });
                });
                if (newScheduleForPayload.length > 0) {
                    newPayload[service.service.slug].available_days = [
                        ...newScheduleForPayload,
                    ];
                }
                newPayload[service.service.slug].cancellation_policy_id =
                    auth.user.services[serviceIndex].cancellation_policy_id;
                newPayload[service.service.slug].hour_availability_id =
                    auth.user.services[serviceIndex].hour_availability_id;
                if (auth.user.services[serviceIndex].service_types) {
                    newPayload[service.service.slug].service_types = [
                        ...auth.user.services[serviceIndex].service_types,
                    ];
                } else {
                    newPayload[service.service.slug].service_types = [];
                }
                newPayload[service.service.slug].service_for_age_id =
                    auth.user.services[serviceIndex].service_for_age_id;
            } else {
                newPayload[service.service.slug] = {...emptyService};
            }
        });
        setOtherService(newOtherService);
        setPayload(newPayload);
        setLoading(false);
        if (auth.user.services[0]?.per_hour != "0") {
            if (!query.get("back")) {
                navigate("/care-giver-registration-3?back=true");
            }
        }
    }, []);

    // console.log("Payload",payload);
    useEffect(()=>{
        // console.log("auth.user.services",auth.user.services);
        auth.user.services?.map((service,index)=>{
            service?.service?.cancellation_policy?.map((policy,key)=>{
                if(key === 0){
                    // console.log("cancellation_policy",service?.service?.slug,policy?.id);
                    setPayload((prevState)=>{
                        return {
                            ...prevState,
                            [service?.service?.slug] : {
                                ...prevState[service?.service?.slug],
                                cancellation_policy_id : policy?.id,
                            }
                        }
                    })
                }
            })
        })
    },[auth.user.services])


    const submit = async () => {
        // onCancellationPolicyChange();
        updateServices(payload, () =>
            navigate("/care-giver-registration-3?back=true")
        ).then();
    };

    if (loading) {
        return <div/>;
    }

    return (
        <>
            <Header/>
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Care Giver Registration</h2>
                            <p>
                                You can register and connect with a specialist
                                caregiver or home-helper by following our 5-step
                                easy process.
                            </p>
                        </div>
                        <div className="tab_nav" role="tablist">
                            <span className="borderTop"></span>
                            <ul
                                className="navs nav-tabs"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item">
                                    <span className="count">1</span>
                                    <h6>Service Selection</h6>
                                </li>

                                <li className="nav-item active">
                                    <span className="count">2</span>
                                    <h6>Service Setup</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">3</span>
                                    <h6>Build Trust</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">4</span>
                                    <h6>Finalization</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">5</span>
                                    <h6>Payment</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div id="wizard">
                        <h6>Second</h6>
                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#">Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button>
                                <button className="btn ml-2" onClick={submit}>
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                        <section id="tabcontent" className="second_tab">
                            <div className="head_wrapper">
                                <h5>Services Setup</h5>
                                <p>
                                    Select Services you want to provide .You can
                                    select multiple service
                                </p>
                            </div>
                            <div id="accordion">
                                <form action="#" id="" method="POST">
                                    {auth.user.services.map(
                                        (service, serviceIndex) => {
                                            return (
                                                <div
                                                    className="card"
                                                    key={service.id.toString()}
                                                >
                                                    <div
                                                        className="card-header"
                                                        id={`form_${service.id}`}
                                                    >
                                                        <h5 className="mb-0">
                                                            <button
                                                                type="button"
                                                                className="btn btn-link"
                                                                data-toggle="collapse"
                                                                data-target={`#form_${service.id}_collapse`}
                                                                aria-expanded="true"
                                                                aria-controls={`form_${service.id}_collapse`}
                                                                data-bs-toggle="collapse"
                                                            >
                                                                <div className="care_dropdown">
                                                                    <div className="header_bar">
                                                                        <div className="icon_bar">
                                                                            <img
                                                                                src={
                                                                                    config.assetUrl +
                                                                                    "uploads/" +
                                                                                    service
                                                                                        .service
                                                                                        .image
                                                                                }
                                                                                alt=""
                                                                            />
                                                                            <h5 className="title">
                                                                                {
                                                                                    service
                                                                                        .service
                                                                                        .title
                                                                                }
                                                                            </h5>
                                                                        </div>
                                                                        <div className="ques">
                                                                            <p>
                                                                                {
                                                                                    service
                                                                                        .service
                                                                                        .description
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="drop">
                                                                        <FontAwesomeIcon
                                                                            aria-hidden={
                                                                                true
                                                                            }
                                                                            icon={
                                                                                faAngleLeft
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </h5>
                                                    </div>
                                                    <div
                                                        id={`form_${service.id}_collapse`}
                                                        className={`collapse ${
                                                            serviceIndex == 0
                                                                ? "show"
                                                                : ""
                                                        }`}
                                                        aria-labelledby="formone"
                                                        data-parent="#accordion"
                                                    >
                                                        <div className="card-body">
                                                            <div className="offering_service">
                                                                <label>
                                                                    Mark the
                                                                    Services
                                                                    which you
                                                                    are offering
                                                                    in{" "}
                                                                    {
                                                                        service.title
                                                                    }
                                                                    . *
                                                                </label>
                                                                <div className="checkboxes">
                                                                    {service.service.service_types.map(
                                                                        (
                                                                            serviceType
                                                                        ) => (
                                                                            <div
                                                                                className="form-group"
                                                                                key={serviceType.id.toString()}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`service_type_${serviceType.id}`}
                                                                                    name="service_types[]"
                                                                                    value={
                                                                                        serviceType.title
                                                                                    }
                                                                                    checked={payload[
                                                                                        service
                                                                                            .service
                                                                                            .slug
                                                                                        ]?.service_types?.includes(
                                                                                        serviceType.title
                                                                                    )}
                                                                                    onChange={() =>
                                                                                        onCheckServiceType(
                                                                                            service
                                                                                                .service
                                                                                                .slug,
                                                                                            serviceType.title
                                                                                        )
                                                                                    }
                                                                                ></input>
                                                                                <label htmlFor="bathing">
                                                                                    {
                                                                                        serviceType.title
                                                                                    }
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="others">
                                                                <div className="form-group">
                                                                    <div className="input_field">
                                                                        <label htmlFor="specify">
                                                                            Other
                                                                            (please
                                                                            specify)
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Specify Your Service "
                                                                            value={
                                                                                otherService[
                                                                                    service
                                                                                        .service
                                                                                        .slug
                                                                                    ]
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                onOtherServiceType(
                                                                                    service
                                                                                        .service
                                                                                        .slug,
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="note">
                                                                        <span>
                                                                            <ruby>
                                                                                Note:
                                                                            </ruby>
                                                                            {" "}
                                                                            please
                                                                            Specify
                                                                            if
                                                                            the
                                                                            service
                                                                            you
                                                                            offer
                                                                            is
                                                                            not
                                                                            listed
                                                                            above
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group pt-4">
                                                                    <div className="input_field">
                                                                        <label htmlFor="specify">
                                                                            Per
                                                                            hour
                                                                            charges
                                                                            clients
                                                                            to
                                                                            pay
                                                                            per
                                                                            service:
                                                                            *
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            placeholder="$"
                                                                            value={
                                                                                payload[
                                                                                    service
                                                                                        .service
                                                                                        .slug
                                                                                    ]
                                                                                    ?.per_hour
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                onPerHourChange(
                                                                                    service
                                                                                        .service
                                                                                        .slug,
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="note">
                                                                        <span>
                                                                            <ruby>
                                                                                Note:
                                                                            </ruby>
                                                                            {" "}
                                                                            What
                                                                            you’ll
                                                                            earn
                                                                            per
                                                                            service:
                                                                            $
                                                                            {parseFloat(
                                                                                payload[
                                                                                    service
                                                                                        .service
                                                                                        .slug
                                                                                    ]
                                                                                    ?.per_hour *
                                                                                0.9
                                                                            ).toFixed(
                                                                                2
                                                                            )}
                                                                            |
                                                                            10%
                                                                            processing
                                                                            fee
                                                                            will
                                                                            be
                                                                            charge
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="week_days">
                                                                <p>
                                                                    What days of
                                                                    the week
                                                                    will you
                                                                    typically be
                                                                    available? *
                                                                </p>
                                                                <ul className="days">
                                                                    {days.map(
                                                                        (
                                                                            day
                                                                        ) => (
                                                                            <li
                                                                                key={
                                                                                    day.value
                                                                                }
                                                                            >
                                                                                <div className="form-group">
                                                                                    <label
                                                                                        htmlFor={`${day.id}_${service.service.slug}`}
                                                                                    >
                                                                                        {
                                                                                            day.label
                                                                                        }
                                                                                    </label>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`${day.id}_${service.service.slug}`}
                                                                                        value={
                                                                                            day.value
                                                                                        }
                                                                                        checked={(() => {
                                                                                            let checked =
                                                                                                payload[
                                                                                                    service
                                                                                                        .service
                                                                                                        .slug
                                                                                                    ]?.available_days?.map(
                                                                                                    (
                                                                                                        available_day
                                                                                                    ) => {
                                                                                                        if (
                                                                                                            available_day.label ==
                                                                                                            day.value
                                                                                                        ) {
                                                                                                            return available_day.value;
                                                                                                        }
                                                                                                    }
                                                                                                );
                                                                                            if (
                                                                                                checked?.length >
                                                                                                0
                                                                                            ) {
                                                                                                return checked[0];
                                                                                            }
                                                                                            return false;
                                                                                        })()}
                                                                                        onChange={(
                                                                                            e
                                                                                        ) =>
                                                                                            onDaysChange(
                                                                                                service
                                                                                                    .service
                                                                                                    .slug,
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            </div>
                                                            <div className="hoursDv combined_radios">
                                                                <p>
                                                                    How many
                                                                    hours per
                                                                    day you are
                                                                    available on
                                                                    average *
                                                                </p>
                                                                <ul className="hours_radios combined_list row">
                                                                    {service.service.hours_per_day?.map(
                                                                        (
                                                                            singleHourAvailability,
                                                                            index
                                                                        ) => (
                                                                            <li
                                                                                key={`${index}`}
                                                                                className="col-md-3"
                                                                            >
                                                                                <label
                                                                                    htmlFor={`hour_availability_${singleHourAvailability.id}_${service.service.slug}`}
                                                                                    className="hours_container combined_container"
                                                                                >
                                                                                    {singleHourAvailability.min_hours +
                                                                                        " - " +
                                                                                        singleHourAvailability.max_hours +
                                                                                        " Hours / Day"}
                                                                                    <input
                                                                                        id={`hour_availability_${singleHourAvailability.id}_${service.service.slug}`}
                                                                                        type="radio"
                                                                                        value={
                                                                                            singleHourAvailability.id
                                                                                        }
                                                                                        checked={
                                                                                            payload[
                                                                                                service
                                                                                                    .service
                                                                                                    .slug
                                                                                                ]
                                                                                                ?.hour_availability_id ==
                                                                                            singleHourAvailability.id
                                                                                        }
                                                                                        onChange={(
                                                                                            e
                                                                                        ) =>
                                                                                            onHourAvailabilityChange(
                                                                                                service
                                                                                                    .service
                                                                                                    .slug,
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            )
                                                                                        }
                                                                                        name={`hour_availability_${service.service.slug}`}
                                                                                    />
                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            </div>
                                                            <div className="ageDv combined_radios">
                                                                <p>
                                                                    Select your
                                                                    Age Range*
                                                                </p>
                                                                <ul className="age_radios combined_list row">
                                                                    {service.service.service_for_ages?.map(
                                                                        (
                                                                            singleServiceAge,
                                                                            index
                                                                        ) => (
                                                                            <li
                                                                                key={`${index}`}
                                                                                className="col-md-3"
                                                                            >
                                                                                <label
                                                                                    htmlFor={`service_for_age_${singleServiceAge.id}_${service.service.slug}`}
                                                                                    className="age_container combined_container"
                                                                                >
                                                                                    {config.monthsYearsFormatter(
                                                                                            singleServiceAge.min_age
                                                                                        ) +
                                                                                        " - " +
                                                                                        config.monthsYearsFormatter(
                                                                                            singleServiceAge.max_age
                                                                                        )}
                                                                                    <input
                                                                                        id={`service_for_age_${singleServiceAge.id}_${service.service.slug}`}
                                                                                        type="radio"
                                                                                        checked={
                                                                                            payload[
                                                                                                service
                                                                                                    .service
                                                                                                    .slug
                                                                                                ]
                                                                                                ?.service_for_age_id ==
                                                                                            singleServiceAge.id
                                                                                        }
                                                                                        name={`service_for_age_${service.service.slug}`}
                                                                                        value={
                                                                                            singleServiceAge.id
                                                                                        }
                                                                                        onChange={(
                                                                                            e
                                                                                        ) =>
                                                                                            onServiceAgeChange(
                                                                                                service
                                                                                                    .service
                                                                                                    .slug,
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            </div>
                                                            <div className="childcare combined_radios p-0">
                                                                {/*<p>*/}
                                                                {/*    What is your*/}
                                                                {/*    Cancellation*/}
                                                                {/*    Policy for{" "}*/}
                                                                {/*    {*/}
                                                                {/*        service*/}
                                                                {/*            .service*/}
                                                                {/*            .title*/}
                                                                {/*    }{" "}*/}
                                                                {/*    Service**/}
                                                                {/*</p>*/}
                                                                <ul className="childcare combined_list row"
                                                                    style={{visibility: 'hidden'}}>
                                                                    {service.service.cancellation_policy?.map(
                                                                        (
                                                                            singlePolicy,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <li key={`${index}`}
                                                                                    className="col-md-3">
                                                                                    <label
                                                                                        htmlFor={`cancellation_policy_${singlePolicy.id}_${service.service.slug}`}
                                                                                        className="childcare combined_container"
                                                                                    >
                                                                                        {(singlePolicy.days ==
                                                                                            0
                                                                                                ? "Same"
                                                                                                : singlePolicy.days) +
                                                                                            " Day(s)"}
                                                                                        <input
                                                                                            type="radio"
                                                                                            id={`cancellation_policy_${singlePolicy.id}_${service.service.slug}`}
                                                                                            checked={
                                                                                                    payload[
                                                                                                        service
                                                                                                            .service
                                                                                                            .slug
                                                                                                        ]
                                                                                                        ?.cancellation_policy_id ==
                                                                                                    singlePolicy.id
                                                                                            }
                                                                                            name={`cancellation_policy_${service.service.slug}`}
                                                                                            value={
                                                                                                singlePolicy.id
                                                                                            }
                                                                                            onChange={(
                                                                                                e
                                                                                            ) =>
                                                                                                onCancellationPolicyChange(
                                                                                                    service.service.slug,
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                        <span
                                                                                            className="checkmark"></span>
                                                                                    </label>
                                                                                </li>
                                                                            )
                                                                        }
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </form>
                            </div>
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#">Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button>
                                <button className="btn ml-2" onClick={submit}>
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Footer/>
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    updateServices: async (payload, cb) =>
        dispatch(await UpdateServicesAction(payload, cb)),
    getInfo: async () => dispatch(await GetInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CareRegistration2);
